import React from "react";
import tw from "twin.macro";

import { PrimaryButton, Link2 } from "../Components/MiscStyles/Buttons";

const Container = tw.div`relative md:mb-0 mb-80`;

const Header = tw.div`h-90 bg-secondary relative`;
const HeaderContent = tw.div`text-white absolute bottom-0  md:mx-72 mx-10   pb-10 text-4xl`;

const Content = tw.div` md:mx-72 mx-10  my-20 `;
const FlexContainer = tw.div`md:flex  items-center`;

const Section2 = tw.div` bg-gray-200`;
const WideContainer = tw.div`md:w-8/12 md:pl-72 md:pr-24 mx-10`;
const SmallContainer = tw.div`md:w-4/12`;

const Section3 = tw.div`mb-16 md:mb-0`;
const SecondWideContainer = tw.div`md:w-8/12 md:pr-72 md:pl-24 mx-10`;
const SecondSmallContainer = tw.div`md:w-4/12`;

const Heading = tw.h2`text-3xl  font-playfair`;
const HeadingMain = tw.h2`text-3xl text-center font-playfair`;
const Subheading = tw.h5`text-sm my-4 `;
const Paragraph = tw.h5`text-sm my-4 opacity-70 `;
const HeaderParagraph = tw.h5`text-smm my-2 w-3/4`;

export default () => {
  return (
    <Container>
      <Header>
        <HeaderContent>
          <Heading>SERVICES</Heading>
          <HeaderParagraph>
            SEE BELOW TO HAVE A GREATER UNDERSTANDING OF WHAT SINGH DRYWALL
            HAS TO OFFER, WHERE WE ARE GOING AND WHAT WE HOLD IMPORTANT TO US AS A
            COMPANY
          </HeaderParagraph>
        </HeaderContent>
      </Header>
      <Content>
        <HeadingMain>A Solution For Every Need</HeadingMain>
        <Paragraph>
          As projects become more complex and schedules become more aggressive,
          Construction Management arrangements have become more common.In this
          approach, the Client and Construction Manager agree on a fee structure
          for the Construction Manager’s costs and fee. This can be established
          based upon fixed numbers or based upon percentages of the cost of the
          Subcontractor/Vendor costs.
          <br />
          <br /> Construction Management arrangements provide less initial cost
          certainty, but the Construction Manager acts as the client’s agent and
          solely in the best interests of the client and project from the
          outset.
          <br />
          <br /> Contractually, CJS will manage and coordinate all trades from
          start to finish. We will hold each individual contract (same as
          general contracting), but the client/design team will have full
          visibility into all sub-contractor and vendor costs through the
          bidding, buy out and award processes.
          <br />
          <br />
          CJS will competitively bids all aspects of the project, which ensures
          that we are achieving the most cost effective and responsible price
          for each trade.
          <br />
          <br />
          This approach gives significantly more visibility into all project
          costs and offers the possibility of a shared returned savings to the
          Client for any costs that come in under the project budget.
        </Paragraph>
      </Content>
      <Section2>
        <FlexContainer>
          <WideContainer>
            <Heading>Insulating a Wall</Heading>
            <Paragraph>
              Insulating a wall, either internally, externally or in a cavity, is an important part of achieving thermally efficient home. Not only is a more efficient home better for the environment but a home where heat loss is kept to a minimum means lower energy bills and increased long-term savings.
              <br />
              <br /> On many projects, this could result in reducing the overall
              schedule by weeks or even months.
            </Paragraph>
          </WideContainer>
          <SmallContainer>
            <img src="https://cdn.mos.cms.futurecdn.net/NgWAW2BroSo6PaBYG8BYJL-970-80.jpg.webp" />
          </SmallContainer>
        </FlexContainer>
      </Section2>

      <Section3>
        <FlexContainer>
          <SecondSmallContainer>
            <img src="https://www.drywallpro-cut.co.uk/wp-content/uploads/2021/01/Drywall4.png" />
          </SecondSmallContainer>

          <SecondWideContainer>
            <Heading>Drywall</Heading>
            <Paragraph>
              Drywall is a construction material. It often goes by the name of wall board, gypsum board or sheetrock. Moreover, it is commonly used to create walls and ceilings. However, it has other uses alongside being the core, inside structures of a building. For instance, you can use it to enhance or create other design aspects in a room. Including arches, eaves, and other architectural features.
            </Paragraph>
            <Paragraph>
              If you would like to find out more about our drywall solutions here at Singh Drywall, then head to our website today. Alternatively, you can email gagansahi@singhdrywall.com to speak to a member of our helpful and friendly team.
            </Paragraph>
          </SecondWideContainer>
        </FlexContainer>
      </Section3>


      <Section2>
        <FlexContainer>
          <WideContainer>
            <Heading>Mud & Tape</Heading>
            <Paragraph>
              Taping and mudding is the process that joins pieces of drywall into a single solid wall. Drywall tape and coats of drywall compound are applied to reinforce joints and conceal screws and nails. When taping and mudding are done correctly, the wall is flat and smooth and the seams underneath are hard to see.
            </Paragraph>
          </WideContainer>
          <SmallContainer>
            <img src="https://www.nakshaconstruction.com/wp-content/uploads/2022/01/aa924ab2170b35f70186be348bbb27c9.jpg" />
          </SmallContainer>
        </FlexContainer>
      </Section2>

      <Section3>
        <FlexContainer>
          <SecondSmallContainer>
            <img src="https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/Articles/how-to-tape-and-mud-drywall-step-4.jpg" />
          </SecondSmallContainer>

          <SecondWideContainer>
            <Heading>Commercial & Industrial Painting</Heading>
            <Paragraph>
              We offer a long list of specialised services related to repainting commercial and industrial buildings. We apply special coating systems that are more durable than conventional paints i.e. less prone to fading, chalking and rusting
            </Paragraph>
            <br />
            <PrimaryButton href="/ContactUs">GET IN TOUCH</PrimaryButton>

            <br />
            <br />
            <br />
          </SecondWideContainer>
        </FlexContainer>
      </Section3>

    </Container >
  );
};
